import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mikwe',
  templateUrl: './mikwe.component.html',
  styleUrls: ['./../app.component.css']
})
export class MikweComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
